module.exports = __webpack_public_path__ + "static/media/Unsplash_Memory_Game.cd38aec0.png";